module.exports = " <span (click)=resellerClicked()>{{resellerName}}</span> ";